import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import data from "assets/TransportTranslation.json";

const fallbackLng = ["en"];

const en = {};
const am = {};
const om = {};
data.forEach((x) => {
  en[x.KEY] = x.TRANSLATION.EN;
  am[x.KEY] = x.TRANSLATION.AM;
  om[x.KEY] = x.TRANSLATION.OM;
});

i18n
  .use(Backend) // used to load data from othe directory
  .use(LanguageDetector) // detects the current language
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    fallbackLng, // default language
    detection: {
      checkWhitelist: true,
    },
    debug: false,
    interpolation: {
      escapeValue: false, // no need for react. it escapes by default
    },
    resources: {
      en: { translation: en },
      am: { translation: am },
      om: { translation: om },
    },
  });

export default i18n;
